<template>
  <!-- 报名抽签弹窗 -->
  <el-dialog
    :model-value="show"
    title="参与报名抽签"
    width="400px"
    :append-to-body="true"
    :before-close="handleClose"
  >
    <el-form :model="form" ref="applyFormRef" :rules="rules" label-position="top" @submit.prevent>
      <el-form-item label="手机号码" prop="phone">
        <el-input
          v-model="form.phone"
          size="large"
          placeholder="请输入手机号"
          maxlength="11"
        ></el-input>
      </el-form-item>
    </el-form>
    <ol class="draw-hint">
      <li class="hint-content">请输入报名时填写的手机号，才能进行抽签</li>
    </ol>
    <template #footer>
      <div class="dialog-footer">
        <el-button
          class="btn"
          size="large"
          type="primary"
          :disabled="!form.phone"
          @click="handleBallot"
        >
          开始抽签
        </el-button>
      </div>
    </template>
  </el-dialog>
  <!-- 抽签动画 -->
  <BallotAnimate v-if="showAnimate" />
</template>

<script setup>
import BallotAnimate from './BallotAnimate.vue'
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  liveId: String
})

const { trainSignBallot } = inject('$http')
const showAnimate = ref(false)

const emit = defineEmits(['update:show', 'ballotResult'])

const form = reactive({
  phone: ''
})
const applyFormRef = ref()
const rules = {
  phone: [{ required: true, pattern: /^[1][0-9]{10}$/, message: '请输入正确手机号', trigger: 'blur' }]
}

const handleClose = () => {
  emit('update:show', false)
}

// 抽签
const handleBallot = async () => {
  applyFormRef.value.validate(async valid => {
    if (valid) {
      const data = await trainSignBallot({ liveId: props.liveId, phoneNumber: form.phone })
      handleClose()
      showAnimate.value = true
      setTimeout(() => {
        showAnimate.value = false
        emit('ballotResult', data)
      }, 2500)
    }
  })
}
</script>

<style lang="scss" scoped>
.draw-hint {
  margin-top: 20px;
  margin-left: 15px;
  .hint-content {
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #666666;
    padding-left: 10px;
    & + .hint-content {
      margin-top: 10px;
    }
  }
}

.dialog-footer {
  margin-top: 20px;
  .btn {
    width: 96px;
    border-radius: 20px;
  }
}
</style>
